import {
    createContext,
    useContext,
    useEffect,
    useState,
} from "react";
import {
    collection,
    doc,
    getDocs,
    limit,
    onSnapshot,
    orderBy,
    query,
    where,
} from "firebase/firestore";
import { db } from "../../Firebase/firebase_init";

const AdminContext = createContext(null);

export function AdminProvider({ children }) {
    const [counters, setCounters] = useState([]);
    const [payments, setPayments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const unsubscribe = onSnapshot(doc(db, 'statistics', 'counters'), (snapshot) => {
            if (snapshot.exists()) {
                const webData = snapshot.data();
                setCounters(webData);
            }
        });
        return () => unsubscribe();
    }, []);

    useEffect(() => {
        let cancelled = false;

        async function loadStatistics() {
            try {
                setLoading(true);
                setError(null);

                const q = query(
                    collection(db, "payments"),
                    orderBy("createdAt", "desc"),
                    where("is_payment", "==", true),
                    where("paid", "==", true),
                    limit(5)
                );

                const snapshot = await getDocs(q);

                const data = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                console.log("ADAD", data);
                if (!cancelled) {
                    setPayments(data);
                }
            } catch (err) {
                console.log(err);
                if (!cancelled) {
                    setError(err);
                }
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        }

        loadStatistics();

        return () => {
            cancelled = true;
        };
    }, []);

    return (
        <AdminContext.Provider
            value={{
                payments,
                counters,
                loading,
                error,
            }}
        >
            {children}
        </AdminContext.Provider>
    );
}

export function useAdmin() {
    const context = useContext(AdminContext);

    if (!context) {
        throw new Error(
            "useStatistics must be used inside StatisticsProvider"
        );
    }

    return context;
}